<h2 i18n class="title-vertical-center">Scan croupier card to continue</h2>
